// User constants (stub for parents)

export const FAVORITE_COLORS = [
  { id: "red", name: "あか", color: "#FF0000" },
  { id: "blue", name: "あお", color: "#0000FF" },
  { id: "green", name: "みどり", color: "#00FF00" },
  { id: "yellow", name: "きいろ", color: "#FFFF00" },
  { id: "pink", name: "ピンク", color: "#FFC0CB" },
  { id: "purple", name: "むらさき", color: "#800080" },
  { id: "orange", name: "オレンジ", color: "#FFA500" },
  { id: "black", name: "くろ", color: "#000000" },
  { id: "white", name: "しろ", color: "#FFFFFF" },
];

export const FAVORITE_THINGS = [
  "sports",
  "music",
  "games",
  "reading",
  "art",
  "animals",
  "nature",
  "science",
  "cooking",
  "travel",
];

// Color palette for AI generation
export type BaseColorKey = "red" | "blue" | "green" | "yellow" | "white";

export const COLOR_PALETTE: Array<{
  key: BaseColorKey;
  labelKey: string;
  hex: string;
}> = [
  { key: "red", labelKey: "MSG_COLOR_RED", hex: "#EF4444" },
  { key: "blue", labelKey: "MSG_COLOR_BLUE", hex: "#3B82F6" },
  { key: "yellow", labelKey: "MSG_COLOR_YELLOW", hex: "#EAB308" },
  { key: "green", labelKey: "MSG_COLOR_GREEN", hex: "#22C55E" },
  { key: "white", labelKey: "MSG_COLOR_WHITE", hex: "#FFFFFF" },
];

export const generateColorVariations = (_baseColor: BaseColorKey): string[] => {
  // Stub - returns empty array in parents
  return [];
};

// Profile field options
export const HAIRSTYLE_OPTIONS = [
  { id: "short", name: "みじかい" },
  { id: "medium", name: "ふつう" },
  { id: "long", name: "ながい" },
];

export const BODY_TYPE_OPTIONS = [
  { id: "slim", name: "ほそい" },
  { id: "normal", name: "ふつう" },
  { id: "large", name: "おおきい" },
];

export const FACE_SHAPE_OPTIONS = [
  { id: "round", name: "まる" },
  { id: "oval", name: "たまご" },
  { id: "square", name: "しかく" },
];
